import {Obj} from '../utility'
import {getLocalConfig} from './config'
import {localizationEvents} from './events'
import {Keywords, TranslatableKeyword, TranslationsList} from './types'

/**
 * Current locale code
 */
let currentLocaleCode = 'en'

/**
 * fall back locale code
 */
let fallbackLocaleCode = 'en'

/**
 * Translations list
 */
let translationsList: TranslationsList = {}

/**
 * Get current locale code
 *
 * @returns {string}
 */
export function getCurrentLocaleCode() {
  return currentLocaleCode
}

/**
 * set locale code
 * @param localeCode
 */
export function setLocaleCode(localeCode: string): void {
  const oldLocaleCode = currentLocaleCode

  currentLocaleCode = localeCode

  localizationEvents.trigger('localeCode', localeCode, oldLocaleCode)
}

/**
 * Translations of keywords
 *
 * @param translationsList
 */
export function setTranslationsList(translations: TranslationsList) {
  translationsList = translations
}

/**
 * Add list of translations to the given locale code
 * @param localeCode
 * @param keywords
 */
export function extend(localeCode: string, keywords: Keywords) {
  translationsList[localeCode] = Obj.merge(translationsList[localeCode] || {}, keywords) as Keywords
}

/**
 * translate the keyword
 *
 * @param keyword
 * @param placeholder
 * @returns
 */
export function trans(keyword: TranslatableKeyword, placeholders?: Record<string, any>) {
  const fallbackWord = Obj.get(translationsList, `${fallbackLocaleCode}.${keyword}`, null)

  const translation = Obj.get(translationsList, `${currentLocaleCode}.${keyword}`, fallbackWord)

  if (!translation) return keyword

  return placeholders ? convertVariable(translation, placeholders) : translation
}

/**
 * convert dynamic text
 *
 * @param translation
 * @param placeholders
 * @returns
 */
export function convertVariable(translation: string, placeholders: Record<string, any>) {
  const listOfPlaceholdersKeys = Object.keys(placeholders).map((key) =>
    key.startsWith(':') ? key : ':' + key
  )
  const expression = `(${listOfPlaceholdersKeys.join('|')})`

  const regex = new RegExp(expression, 'g')

  return translation.replace(regex, (capture: string) => {
    // Remove `:` from first
    return placeholders[capture.substring(1)]
  })
}
